import { HTMLAttributes, FC, ReactNode } from "react";

import styles from "./styles.module.css";

export interface NoResultsFoundProps extends HTMLAttributes<HTMLDivElement> {
  message?: ReactNode;
}

export const NoResultsFound: FC<NoResultsFoundProps> = ({
  message = "No results found",
  ...props
}) => {
  return (
    <p className={styles.noResults} {...props}>
      {message}
    </p>
  );
};
